/* eslint-disable */
import Vue, { KeepAlive } from "vue";
import Router from "vue-router";
import store from "@/common/store/";
import Cookies from "js-cookie";
import { setAgentCode } from "@/common/utils/initRegisterAgentCode.js";
import { scrollToTop } from "@/common/utils/index.js";
import i18n from "../i18n/i18n";
import NProgress from "nprogress";

const files = require.context("./module/", true, /\.js$/);
const modules = [];
files.keys().forEach((key) => {
  if (files(key).default) modules.push(files(key).default);
});
Vue.use(Router);

const _import = (name) => {
  return (resolve) => require([`../views/${name}`], resolve);
};

// export default
const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "",
      component: () => import("../views/main/"),
      children: [
        {
          path: "",
          redirect: "/home",
        },
        // 德州
        {
          path: "/texas",
          meta: {
            navShow: true,
          },
          name: "Texas",
          component: () => import("../views/texas/"),
        },
        {
          path: "/game/:id",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "Game",
          component: _import("game"),
        },
        {
          path: "/game-play",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "Game-Play",
          component: _import("gamePlay"),
        },
        // 优惠
        {
          path: "/discounts",
          meta: {
            navShow: true,
            isRefreshAccount: true,
          },
          name: "discounts",
          component: () => import("../views/discounts/"),
        },
        {
          path: "/discounts/discountsDetail",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "discountsDetail",
          component: () => import("../views/discounts/discountsDetail/"),
        },
        {
          path: "/register",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "register",
          component: () => import("../views/register/"),
        },
        {
          path: "/download",
          component: () => import("../views/download/"),
          name: "download",
          meta: {
            navShow: false,
            isRefreshAccount: false,
            titleHide: true,
          },
        },

        // 找回密码
        {
          path: "/forgetPassword",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "forgetPassword",
          component: () => import("../views/forgetPassword/forgetPassword"),
        },
        {
          path: "/findPassword",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "findPassword",
          component: () => import("../views/forgetPassword/findPassword"),
        },
        //签到
        // {
        //   path: "/sign",
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true,
        //   },
        //   name: "sign",
        //   component: () => import("../views/sign/sign"),
        // }, //签到主页
        // {
        //   path: "/integral",
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true,
        //   },
        //   name: "integral",
        //   component: () => import("../views/sign/integral"),
        // }, //积分记录
        // {
        //   path: "/exchange",
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true,
        //   },
        //   name: "exchange",
        //   component: () => import("../views/sign/exchange"),
        // }, //兑换记录
        // {
        //   path: "/rule",
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true,
        //   },
        //   name: "rule",
        //   component: () => import("../views/sign/rule"),
        // }, //规则

        //转盘主页app跳转
        {
          path: "/raffle",
          meta: {
            navShow: false,
            titleHide: true,
          },
          name: "raffle",
          component: () => import("../views/raffle/"),
        },
        // 红包雨
        {
          path: "/redPacket",
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth: true,
          },
          name: "redPacket",
          component: () => import("../views/redPacket/"),
        },
        // 红包雨
        {
          path: "/dailyDraw",
          meta: {
            navShow: false,
            titleHide: true,
            requireAuth: true,
          },
          name: "dailyDraw",
          component: () => import("../views/dailyDraw/"),
        },
        // {
        //   path: "/wheel",
        //   meta: {
        //     navShow: false,
        //     titleHide: false,
        //   },
        //   name: "wheel",
        //   component: () => import("@/common/components/wheel/"),
        // },
        //新转盘
        // {
        //   path: "/newwheel",
        //   meta: {
        //     navShow: false,
        //     titleHide: false,
        //   },
        //   name: "newwheel",
        //   component: () => import("@/common/components/wheel-new/"),
        // },
        //欧洲杯
        // {
        //   path: "/Europe",
        //   redirect: "/Europe/index",
        //   meta: {
        //     navShow: false,
        //     titleHide: true,
        //     requireAuth: true,
        //   },
        //   name: "Europe",
        //   component: () => import("../../../common/components/game/Europe"),
        //   children: [
        //     {
        //       path: "index",
        //       meta: { navShow: false, requireAuth: true, titleHide: true },
        //       name: "Europe/index",
        //       component: () =>
        //         import("../../../common/components/game/Europe/Europe.vue"),
        //     },
        //     {
        //       path: "Details",
        //       meta: { navShow: false, requireAuth: true, titleHide: true },
        //       name: "Europe/Details",
        //       component: () =>
        //         import("../../../common/components/game/Europe/Details.vue"),
        //     },
        //   ],
        // },
        // 新加路由
        ...modules,
      ],
    },

    // 404
    {
      path: "/404",
      meta: {
        navShow: false,
        titleHide: true,
      },
      name: "notfound",
      component: () => import("../../../common/notfound/404"),
    },
    {
      path: "*",
      meta: {
        navShow: false,
        titleHide: true,
      },
      redirect: "/home",
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

router.beforeEach(function (to, from, next) {
  NProgress.start();
  store.commit("SET_LOGIN_HIDE");
  store.commit("SET_REGISTER", false);

  setAgentCode(store, 800); // Cookies
  scrollToTop(); // 跳转后滚动到顶部
  if (to.query.isApp == "true") {
    store.commit("setIsApp", true);
    to.meta.navShow = false;
    to.meta.titleHide = true;
  } else {
    store.commit("setIsApp", false);
  }
  if (to.query.lang) {
    let lang = to.query.lang;
    i18n.locale = lang;
    Cookies.set("lang", lang);
    store.commit("setlangs", { keys: lang });
  } else {
  }
  store.commit("set_tab", 5);
  store.commit("updateLoadingStatus", {
    isLoading: true,
  });

  if (to.matched.some((r) => r.meta.requireAuth)) {
    if (Cookies.get("UUID")) {
      next();
    } else {
      if (to.query.UUID) {
        next();
      } else {
        next(from.fullPath);
        // const pathArr = ['/home', '/discounts', '/Service', '/My'] // 未登录无需跳转的路由
        // if (!pathArr.includes(from.path)) next({ path: '/' })
        store.commit("LOGIN_OUT");
        store.commit("SET_LOGIN_SHOW");
        store.commit("updateLoadingStatus", {
          isLoading: false,
        });
      }
    }
  } else {
    next();
  }
});

var routerTime2 = null;
router.afterEach((to) => {
  clearTimeout(routerTime2);
  let onloadTime = setInterval(() => {
    // document.getElementById('appRouter').style.display = 'none'
    // document.readyState判断当前节点加载状态
    // loading开始加载 interactive文件已经装载完毕，可以访问dom complete页面加载完成
    if (
      document.readyState === "interactive" ||
      document.readyState === "complete"
    ) {
      setTimeout(() => {
        store.commit("updateLoadingStatus", {
          isLoading: false,
        });
      }, 200);
      clearTimeout(onloadTime);
    }
  }, 200);

  routerTime2 = setTimeout(() => {
    store.commit("updateLoadingStatus", { isLoading: false });
    if (to.meta.isRefreshAccount) store.dispatch("refreshAccount"); // 是否提取并更新余额
    clearTimeout(routerTime2);
    clearTimeout(onloadTime);
  }, 3000);
  NProgress.done();
  // livechat.reset(to.path);
});

// var LS = window.localStorage;
// LS.removeItem("LiveChatWidgetCount");
// var livechat = {
//   path: ["/home", "/Service"],
//   timer: null,
//   reset: function (links) {
//     // 显示隐藏livechat
//     clearTimeout(this.timer);
//     if (!window.LiveChatWidget) {
//       const count = LS.getItem("LiveChatWidgetCount") * 1;
//       if (count < 2) {
//         LS.setItem("LiveChatWidgetCount", count + 1);
//         this.reset(links);
//       }
//     } else {
//       LS.removeItem("LiveChatWidgetCount");
//       if (this.path.includes(links)) {
//         window.LiveChatWidget.call("minimize");
//       } else {
//         window.LiveChatWidget.call("hide");
//         this.timer = setTimeout(() => {
//           window.LiveChatWidget.call("hide");
//           clearTimeout(this.timer);
//         }, 2500);
//       }
//     }
//   },
// };

export default router;



// WEBPACK FOOTER //
// ./src/pages/build800/router/index.js